import React from 'react';
import { Box, createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import BoxFancyScroll from '@components/BoxFancyScroll/BoxFancyScroll';
import {
	RecommendedReleases
} from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestPage/ReleasesSection/RecommendedReleases/RecommendedReleases';
import {
	PendingReleases
} from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestPage/ReleasesSection/PendingReleases/PendingReleases';
import BlockReleaseSurgeonSelection
	from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestPage/BlockReleaseSurgeonSelection/BlockReleaseSurgeonSelection';

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			gridArea: 'releases',
			gap: theme.spacing(2),
			overflowY: 'auto',
			paddingRight: theme.spacing(2),
		},
		scrollBox: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing(2),
			paddingRight: theme.spacing(2),
			overflowY: 'auto',
		},
	}),
);

export const ReleasesSection = () => {
	const classes = useStyles();

	return (
		<Box className={classes.root}>
			<BlockReleaseSurgeonSelection />
			<BoxFancyScroll
				className={classes.scrollBox}
				role="region"
				aria-label="Releases list"
			>
				<RecommendedReleases />
				<PendingReleases />
			</BoxFancyScroll>
		</Box>
	);
};
